import type { CurrentUser, LoginBody } from '@flixflow/shared';
import { apiFetch, initCsrf } from './client.js';

export async function login(body: LoginBody): Promise<CurrentUser> {
  return apiFetch<CurrentUser>('/auth/login', {
    method: 'POST',
    body: body,
  });
}

export async function logout(): Promise<void> {
  await apiFetch<void>('/auth/logout', { method: 'POST' });
}

export async function getMe(): Promise<CurrentUser | null> {
  try {
    return await apiFetch<CurrentUser>('/auth/me');
  } catch {
    return null;
  }
}

export { initCsrf };
